import React from 'react';

function Title({ title='Pre Operacional' }) {
    return (
        <h2>{title}</h2>
    );
}

export default Title;
